var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "usdc",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(0 0)",
    fill: "#3e73c4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1733",
    "data-name": "Group 1733",
    transform: "translate(3.445 3.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M17.564,15.274c0-1.485-.895-1.994-2.684-2.206-1.278-.17-1.533-.509-1.533-1.1s.426-.976,1.278-.976a1.26,1.26,0,0,1,1.406.891.32.32,0,0,0,.3.212h.682a.291.291,0,0,0,.3-.3v-.042a2.125,2.125,0,0,0-1.917-1.74V9c0-.17-.128-.3-.34-.34h-.64c-.17,0-.3.127-.34.34v.976a2.166,2.166,0,0,0-2.087,2.079c0,1.4.851,1.951,2.641,2.163,1.193.212,1.576.467,1.576,1.146S15.6,16.5,14.8,16.5c-1.108,0-1.491-.466-1.619-1.1a.311.311,0,0,0-.3-.254h-.724a.291.291,0,0,0-.3.3v.042a2.375,2.375,0,0,0,2.258,2.037v1.018c0,.169.128.3.34.339h.64c.17,0,.3-.127.34-.339V17.522a2.327,2.327,0,0,0,2.13-2.249Z",
    transform: "translate(-7.064 -6.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M10.517,18.779a6.34,6.34,0,0,1,0-11.921.425.425,0,0,0,.255-.424V5.839a.322.322,0,0,0-.255-.339.26.26,0,0,0-.171.042,7.626,7.626,0,0,0,0,14.552.259.259,0,0,0,.383-.17c.043-.042.043-.085.043-.17v-.594a.564.564,0,0,0-.255-.382ZM15.032,5.543a.259.259,0,0,0-.383.169c-.043.043-.043.085-.043.17v.594a.562.562,0,0,0,.255.424,6.34,6.34,0,0,1,0,11.921.425.425,0,0,0-.255.424v.594a.322.322,0,0,0,.255.339.26.26,0,0,0,.171-.042,7.616,7.616,0,0,0,4.984-9.588,7.707,7.707,0,0,0-4.984-5.006Z",
    transform: "translate(-5.001 -5.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/usdc.58b4051766301bb8f17179e923ce0283.svg";
export { ForwardRef as ReactComponent };